'use client';

import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';
import { useAnimation } from '@/context/AnimationContext';

/**
 * FadeScaleIn - Simple fade in + scale up animation with spring physics
 * Triggers once on scroll into view
 */
export default function FadeScaleIn({
    children,
    delay = 0,
    className = ''
}) {
    const ref = useRef(null);
    const { isMobile, shouldAnimate } = useAnimation();
    const isInView = useInView(ref, {
        once: true,
        amount: 0.3
    });

    const isReadyToAnimate = isMobile || (shouldAnimate && isInView);

    return (
        <motion.div
            ref={ref}
            initial={isMobile ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.8 }}
            animate={isReadyToAnimate ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.8 }}
            transition={{
                type: 'spring',
                stiffness: 100,
                damping: 15,
                delay
            }}
            className={className}
        >
            {children}
        </motion.div>
    );
}
